import React, { useRef, useCallback } from 'react'
import { Modal } from 'antd'
import { DefaultJsonForm } from 'src/react-app/components/v2/default-json-form'

export interface TaskModalResult {
  complete_reason: string
}

const ModalSchema = {
  type: 'object',
  required: ['complete_reason'],
  properties: {
    complete_reason: {
      type: 'string',
      title: 'Причина завершения',
      options: {
        type: 'textarea',
        minRows: 3,
      },
    },
  },
}

export function modalOpen(): Promise<TaskModalResult|null> {
  let formData: TaskModalResult = { complete_reason: '' }

  return new Promise(resolve => {
    Modal.confirm({
      icon: null,
      title: 'Завершение задачи',
      content: <Content
        onChange={value => {formData = value}}
        schema={ModalSchema}
      />,
      onOk: () => new Promise((ok, err) => {
        const isRequired = formData?.['complete_reason']
        if(isRequired){
          resolve(formData)
          ok(null)
        }
        err()
      }),
      onCancel(){
        resolve(null)
      }
    })
  })
}

function Content({ onChange, schema }){
  const formDataRef =  useRef({})
  const localOnChange = useCallback(({ formData }) => {
    formDataRef.current = formData
    onChange(formData)
  }, [onChange])

  return (
    <DefaultJsonForm
      formData={formDataRef.current}
      schema={schema}
      onChange={localOnChange}
      orientation={'horizontal'}
    />
  )
}
